<template>
    <v-container>
        <template v-if="dashboard">

            <v-flex xs12 class="text-xs-center text-sm-right">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" flat @click="previousMonth" class="deep-purple--text text--accent-3 ma-0">Iepriekšējais</v-btn>
                    </template>
                    <span>Iepriekšējais mēnesis</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" flat @click="month" class="deep-purple--text text--accent-3 ma-0">Mēnesis</v-btn>
                    </template>
                    <span>Šis mēnesis</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" flat @click="week" class="deep-purple--text text--accent-3 ma-0">Nedēļa</v-btn>
                    </template>
                    <span>Šonedēļ</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" flat @click="day" class="deep-purple--text text--accent-3 ma-0">Diena</v-btn>
                    </template>
                    <span>Šodien</span>
                </v-tooltip>
            </v-flex>

            <v-flex xs12>
                <v-card flat class="mx-2 mt-2">
                    <v-layout row wrap>

                        <v-flex xs12 sm4>
                            <v-card flat class="text-xs-center ma-3">
                                <v-responsive>
                                    <v-sheet class="d-flex" color="blue lighten-2" height="my-auto">
                                        <v-layout column>
                                            <div class="subheading white--text mt-4">
                                                Kopā mazgāšanas
                                            </div>
                                            <span class="white--text display-3 mb-4">{{dashboard.cleanigsCount}}</span>
                                        </v-layout>
                                    </v-sheet>
                                </v-responsive>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm4>
                            <v-card flat class="text-xs-center ma-3">
                                <v-responsive>
                                    <v-sheet class="d-flex" color="teal accent-3" height="my-auto">
                                        <v-layout column>
                                            <div class="subheading white--text mt-4">
                                                Parastās mazgāšanas
                                            </div>
                                            <span class="white--text display-3 mb-4">{{dashboard.nonHazardCleaningsCount}}</span>
                                        </v-layout>
                                    </v-sheet>
                                </v-responsive>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm4>
                            <v-card flat class="text-xs-center ma-3">
                                <v-responsive>
                                    <v-sheet class="d-flex" color="amber lighten-1" height="my-auto">
                                        <v-layout column>
                                            <div class="subheading white--text mt-4">
                                               ADR mazgāšanas
                                            </div>
                                            <span class="white--text display-3 mb-4">{{dashboard.hazardCleaningsCount}}</span>
                                        </v-layout>
                                    </v-sheet>
                                </v-responsive>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-flex>

            <v-layout row wrap>
                <v-flex xs12 md6 class="mt-2" >
                    <v-card flat class="mx-2 card--flex-toolbar" height="100%">
                        <v-toolbar flat color="white">
                            <v-toolbar-title class="subheading grey--text">Izmazgātās kravas</v-toolbar-title>
                        </v-toolbar>

                        <v-divider></v-divider>
                            <v-card-text>
                                <v-layout row wrap class="hidden-md-and-down">
                                    <v-flex md4>
                                        <div class="caption grey--text">Krava</div>
                                    </v-flex>
                                    <v-flex md4>
                                        <div class="caption grey--text">UN nr</div>
                                    </v-flex>
                                    <v-flex md4>
                                        <div class="caption grey--text">Mazgāšanu skaits</div>
                                    </v-flex>
                                </v-layout>

                                <v-card flat v-for="cargo in dashboard.cargosWithCount" :key="cargo.id">
                                    <v-layout row wrap class="mt-2">
                                        <v-flex xs5 md4>
                                            <div>{{cargo.name}}</div>
                                        </v-flex>
                                        <v-flex xs5 md4>
                                            <div v-if="cargo.un_nr">{{cargo.un_nr}}</div>
                                            <div v-else>N/A</div>
                                        </v-flex>
                                        <v-flex xs2 md4>
                                            <div>{{cargo.cleanings_count}}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-card>

                            </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex xs12 md6 class="mt-2">
                    <v-card flat class="mx-2 card--flex-toolbar" height="100%">
                        <v-toolbar flat color="white">
                            <v-toolbar-title class="subheading grey--text">Apkalpotie uzņēmumi</v-toolbar-title>
                        </v-toolbar>

                        <v-divider></v-divider>
                        <v-card-text>
                            <v-layout row wrap class="hidden-md-and-down">
                                <v-flex md4>
                                    <div class="caption grey--text">Uzņēmums</div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="caption grey--text">Reģ. nr</div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="caption grey--text">Mazgāšanu skaits</div>
                                </v-flex>
                            </v-layout>

                            <v-card flat v-for="company in dashboard.companiesWithCount" :key="company.id">
                                <v-layout row wrap class="mt-2">
                                    <v-flex xs9 md4>
                                        <div>{{company.name}}</div>
                                    </v-flex>
                                    <v-flex xs5 md4 class="hidden-md-and-down">
                                        <div v-if="company.reg_nr">{{company.reg_nr}}</div>
                                        <div v-else>N/A</div>
                                    </v-flex>
                                    <v-flex xs3 md4>
                                        <div>{{company.cleanings_count}}</div>
                                    </v-flex>
                                </v-layout>
                            </v-card>

                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-flex xs12 class="mt-2">
                <v-card flat class="mx-2 card--flex-toolbar" height="100%">
                    <v-toolbar flat color="white">
                        <v-toolbar-title class="subheading grey--text">Pēdējās 10 mazgāšanas</v-toolbar-title>
                    </v-toolbar>
                    <v-divider></v-divider>

                    <v-card flat v-for="cleaning in allDashboard.last10Cleanings" :key="cleaning.id">
                        <v-layout row wrap class="pa-3 mb-1">
                            <v-flex xs6 md2>
                                <div class="caption grey--text">Mazgāšanas datums</div>
                                <div>{{cleaning.cleaning_date}}</div>
                            </v-flex>
                            <v-flex xs6 md2>
                                <div class="caption grey--text">Tips</div>
                                <div>{{cleaning.cleaned_item.type}}</div>
                            </v-flex>
                            <v-flex xs6 md2>
                                <div v-if="cleaning.cleaned_item.type === 'Konteiners'" class="caption grey--text">Konteinera nr</div>
                                <div v-else class="caption grey--text">Cisternas nr</div>
                                <div>{{cleaning.cleaned_item.regNr}}</div>
                            </v-flex>
                            <v-flex xs6 md2 class="hidden-md-and-down">
                                <div class="caption grey--text">Klients</div>
                                <div>{{cleaning.customer.name}}</div>
                            </v-flex>
                            <v-flex xs6 md2 class="hidden-md-and-down">
                                <div class="caption grey--text">Krava</div>
                                <div>{{cleaning.cargo.name}}</div>
                            </v-flex>
                            <v-flex xs6 md1 class="hidden-md-and-down">
                                <div class="caption grey--text">Sert. nr</div>
                                <div v-if="cleaning.certificate">{{cleaning.certificate.certificate_nr}}</div>
                                <div v-else>N/A</div>
                            </v-flex>
                            <v-flex xx12 sm4 md1>
                                        <v-tooltip top>
                                            <v-btn icon :to="`/cleanings/${cleaning.id}`" flat small slot="activator">
                                                <v-icon color="grey">open_in_new</v-icon>
                                            </v-btn>
                                            <span>Skatīt mazgāšanu</span>
                                        </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-card>

            </v-flex>

        </template>
    </v-container>
</template>
<script>

    import { mapGetters } from 'vuex'

    export default {
        name: "Dashboard",
        components: {

        },
        data: () => ({

        }),
        created(){
            this.$store.dispatch('getDashboardData')
        },
        computed: {
            ...mapGetters({
                allDashboard: 'allDashboardData',
                dashboard: 'dashboard'
            })
        },

        methods: {
            previousMonth(){
                this.$store.dispatch('getPreviousMonthDashboard')
            },
            month(){
                this.$store.dispatch('getThisMonthDashboard')
            },
            week(){
                this.$store.dispatch('getThisWeekDashboard')
            },
            day(){
                this.$store.dispatch('getLastDayDashboard')
            }
        }
      }
</script>



<style>



</style>

